import { render } from "./MarketingPrompt.vue?vue&type=template&id=2e7b52ba&scoped=true"
import script from "./MarketingPrompt.vue?vue&type=script&lang=js"
export * from "./MarketingPrompt.vue?vue&type=script&lang=js"

import "./MarketingPrompt.vue?vue&type=style&index=0&id=2e7b52ba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-dilatih/frontend-dilatih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7b52ba"]])

export default __exports__